module.exports = __webpack_public_path__ + "static/media/tcsion_logo.ac3b596c.png";